
<dashlet
  title="New Pages"
  [loading]="loading"
  [noResults]="!listResults?.length && !loading"
  >
  <ng-container filter>
    <time-filter
      [DateRange]="DateRange"
      [dateSize]="dateSize"
      (onSetDateSize)="setDateSize($event)"
      (onIncrementStartDate)="incrementStartDate()"
      (onDecrementStartDate)="decrementStartDate()"
      (onStartDateToday)="startDateToday()"
      >
    </time-filter>
  </ng-container>
  @if (!!listResults?.length) {
    <ng-container data>
      <table mat-table [dataSource]="dataSource">
        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
        <ng-container matColumnDef="title">
          <th mat-header-cell *matHeaderCellDef>Title</th>
          <td mat-cell *matCellDef="let row">{{ row.listingTitle }}</td>
        </ng-container>
        <ng-container matColumnDef="created">
          <th mat-header-cell *matHeaderCellDef>Created</th>
          <td mat-cell *matCellDef="let row">{{ row.created }}</td>
        </ng-container>
        <ng-container matColumnDef="actions">
          <th mat-header-cell *matHeaderCellDef>Actions</th>
          <td mat-cell *matCellDef="let row">
            <a
              mat-icon-button
              [href]="row.listingUrl"
              matTooltip="View page."
              target="_blank"
              >
              <mat-icon>visibility</mat-icon>
            </a>
          </td>
        </ng-container>
      </table>
      <mat-paginator
        #paginator
        [pageSize]="pageSize"
        [length]="totalSize"
        [pageIndex]="currentPage"
        (page)="pageEvent = handlePage($event)"
        >
      </mat-paginator>
    </ng-container>
  }
</dashlet>
